import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const solutions = [
  { title: "EdTech Platforms", desc: "Custom LMS with video streaming, assessments, and progress tracking." },
  { title: "Admissions CRM", desc: "Track enquiries, applications, and conversions across your admission funnel." },
  { title: "Student Portal", desc: "Self-service portal for fee payment, attendance, results, and communication." },
  { title: "AI Tutoring", desc: "Personalized AI learning assistants that adapt to each student's pace." },
];

const Education = () => (
  <StitchFeaturePage
    label="INDUSTRIES / EDUCATION"
    title="From admissions"
    titleAccent="to alumni."
    subtitle="EdTech platforms, admissions CRM, and student portals for schools, colleges, and institutes."
    features={solutions}
    ctaLabel="BUILD FOR EDUCATION"
  />
);

export default Education;
